import type {Relation} from "typeorm";
import {ChildEntity, JoinColumn, ManyToOne, OneToOne, RelationId} from "typeorm";
import {Negotiation} from "@/modules/diplomacy/entity";
import {TransferOffer} from "@/modules/transfer-market/entity/TransferOffer";
import {Team} from "@/modules/team/entity";

@ChildEntity()
export class TransferTeamNegotiation extends Negotiation {
  @ManyToOne(() => Team)
  declare target: Relation<Team>;

  @OneToOne(() => TransferOffer, r => r.teamNegotiation, {createForeignKeyConstraints: false})
  @JoinColumn()
  offer: Relation<TransferOffer>;

  @RelationId((e: TransferTeamNegotiation) => e.offer)
  offerId: number;

  get progressCloseLimit(): number | undefined {
    if (this.onceTo > this.onceFrom) {
      return undefined;
    }

    return super.progressCloseLimit;
  }
}
